import './icon.scss';

import { ReactNode } from 'react';

import { IconProps } from './types/IconProps';

export const Icon = ({
  children,
  className = '',
  testId,
  viewBox = '0 0 24 24',
  ...props
}: IconProps): ReactNode => (
  <svg
    aria-hidden="true"
    className={`icon ${className}`.trim()}
    data-testid={testId}
    focusable="false"
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {children}
  </svg>
);
